import type React from 'react'
import penningLogo from '../assets/penning-logo.svg'

type PenningWebsiteHeaderLinkProps = {}

const PenningWebsiteHeaderLink: React.FC<
  PenningWebsiteHeaderLinkProps
> = () => {
  return (
    <div className="absolute top-0 left-0 m-[12px]">
      <a
        href="https://www.penning.io"
        aria-label="Go back to the main Penning website"
      >
        <img src={penningLogo} alt="Penning" width="48" height="48" />
      </a>
    </div>
  )
}

export default PenningWebsiteHeaderLink
